module.exports = __webpack_public_path__ + "static/media/icon-simple-cal-click.aef0b0c3.png";